/**
 * covrfly-cart-page.js
 * FASE 3 — Upsell Carousel + ResizeObserver para /cart
 *
 * Duplica logica del drawer (covrfly-cart-drawer.js) al /cart.
 * Drawer permanece 100% intocable.
 *
 * Consenso cuarto IAs 4/4 — Opcion 4 (Duplicar).
 * Reglas:
 * - Drawer cerrado en /cart, no hay conflicto de listeners
 * - Model sheet singleton (reutilizar si drawer ya lo creo)
 * - sessionStorage SHARED con drawer (cf_upsell_model, cf_upsell_acabado)
 * - Placeholder FUERA de .js-contents (sobrevive Section Rendering)
 */
(function () {
  'use strict';

  // Guard singleton: no re-inicializar si ya cargado (Bomba B)
  if (window.cfCartUpsellInitialized) return;
  window.cfCartUpsellInitialized = true;

  // ============================================================
  // REFERENCIAS DOM
  // ============================================================
  var container = document.getElementById('covrfly-cart-upsell');
  if (!container) return;

  // Estado interno (namespace separado del drawer — Bomba 6g)
  var _products = null;
  var _currentCart = null;
  var _currentModelInfo = null;
  var _fetchToken = 0;
  var _cartProductIds = {};

  // ============================================================
  // UTILIDADES (clonadas del drawer)
  // ============================================================
  // mode='marketing' → Math.floor (upsell left-digit neuromarketing, $599 zona 500)
  // mode undefined   → exacto (fallback legacy)
  function formatMoney(cents, mode) {
    var amount = cents / 100;
    var str;
    if (mode === 'marketing') {
      str = Math.floor(amount).toString();
    } else {
      str = (cents % 100 === 0)
        ? Math.round(amount).toString()
        : amount.toFixed(2);
    }
    var parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;')
              .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getVariantAcabado(variant) {
    if (!variant || !variant.title) return 'Glossy';
    var parts = (variant.title || '').split(' / ');
    if (parts.length < 2) return 'Glossy';
    var last = parts[parts.length - 1].trim();
    if (/^(s[ií]|no)$/i.test(last)) return 'Glossy';
    return last;
  }

  // ============================================================
  // KICKFLIP PROPS PARSER (clonado de drawer L385-418)
  // ============================================================
  function getKickflipProps(item) {
    if (!item || !item.properties) return {};
    var rawProps = item.properties;
    if (rawProps['Selecciona tu marca'] ||
        rawProps['Apple'] ||
        rawProps['Samsung Galaxy'] ||
        rawProps['Samsung'] ||
        rawProps['MagSafe']) {
      return rawProps;
    }
    if (typeof rawProps._mczr_attributes === 'string' && rawProps._mczr_attributes) {
      try {
        var attrs = JSON.parse(rawProps._mczr_attributes);
        if (!Array.isArray(attrs)) return rawProps;
        var flat = {};
        for (var k in rawProps) {
          if (Object.prototype.hasOwnProperty.call(rawProps, k)) {
            flat[k] = rawProps[k];
          }
        }
        attrs.forEach(function (attr) {
          if (attr && typeof attr.key === 'string') {
            flat[attr.key] = attr.value;
          }
        });
        return flat;
      } catch (e) {
        return rawProps;
      }
    }
    return rawProps;
  }

  // ============================================================
  // DETECTAR MODELO DEL CART (covrfly-cart-drawer.js:718-754)
  // ============================================================
  function getCartModelInfo(cart) {
    if (!cart.items || cart.items.length === 0) return null;
    var lastItem = cart.items[cart.items.length - 1];

    // ── KICKFLIP CARROUSEL FIX CAPA 1 (21-abr-2026) ──
    // Detectar producto Kickflip personalizado y extraer modelo de _mczr_attributes.
    // Sin esto, variant_title es vacío para Kickflip y el carrusel abortaba.
    var isKickflipItem = false;
    if (lastItem.properties) {
      var pKeysKf = Object.keys(lastItem.properties);
      for (var ki = 0; ki < pKeysKf.length; ki++) {
        if (pKeysKf[ki].toLowerCase().indexOf('_mczr') !== -1) {
          isKickflipItem = true; break;
        }
      }
    }
    if (isKickflipItem) {
      var kfP = getKickflipProps(lastItem);
      var marcaKf = (kfP['Selecciona tu marca'] || '').toLowerCase();
      var kfModelName = '';
      if (marcaKf === 'apple') {
        kfModelName = kfP['Apple'] || '';
      } else if (marcaKf === 'samsung') {
        kfModelName = kfP['Samsung Galaxy'] || kfP['Samsung'] || '';
      }
      if (!kfModelName) {
        kfModelName = kfP['Apple'] || kfP['Samsung Galaxy'] || kfP['Samsung'] || '';
      }
      if (kfModelName) {
        var isSamsungKf = (marcaKf === 'samsung');
        var isIphone11Kf = /iphone\s*11/i.test(kfModelName);
        var hasMagsafeKf = !(isSamsungKf || isIphone11Kf);
        var magsafeKf = hasMagsafeKf ? 'Si' : null;
        if (hasMagsafeKf) {
          var msKf = kfP['MagSafe'] || '';
          if (!/con\s*magsafe|^s[ií]$|^yes$/i.test(msKf)) magsafeKf = 'No';
        }
        var acabadoKf = (kfP['Acabado'] || kfP['Finish'] || '').toLowerCase() || null;
        return {
          modelName: kfModelName,
          magsafeChoice: magsafeKf,
          acabado: acabadoKf,
          productId: lastItem.product_id
        };
      }
    }
    // ── FIN KICKFLIP DETECTION ──

    var variantTitle = lastItem.variant_title || '';

    var parts = variantTitle.split(' / ');
    var modelName = parts.length > 0 ? parts[0].trim() : '';
    var magsafeChoice = 'Si';
    var acabado = null;

    var isSamsung = /Galaxy|Samsung/i.test(modelName);
    var isIphone11 = /iPhone\s*11/i.test(modelName);
    var hasMagsafe = !(isSamsung || isIphone11);

    if (hasMagsafe && parts.length > 1) {
      var msValue = parts[1].trim().toLowerCase();
      if (/^no$/i.test(msValue)) {
        magsafeChoice = 'No';
      }
    }

    if (hasMagsafe && parts.length >= 3) {
      acabado = parts[2].trim().toLowerCase();
    } else if (!hasMagsafe && parts.length >= 2) {
      acabado = parts[1].trim().toLowerCase();
    }

    // Verificar sessionStorage (sync con drawer)
    try {
      var savedModel = sessionStorage.getItem('cf_upsell_model');
      if (savedModel) {
        modelName = savedModel;
        isSamsung = /Galaxy|Samsung/i.test(savedModel);
        isIphone11 = /iPhone\s*11/i.test(savedModel);
        hasMagsafe = !(isSamsung || isIphone11);
        magsafeChoice = hasMagsafe ? 'Si' : null;
        var savedAcabado = sessionStorage.getItem('cf_upsell_acabado');
        if (savedAcabado) acabado = savedAcabado;
      }
    } catch (e) {}

    return {
      modelName: modelName,
      magsafeChoice: hasMagsafe ? magsafeChoice : null,
      acabado: acabado,
      productId: lastItem.product_id
    };
  }

  // ============================================================
  // FIND MATCHING VARIANT (covrfly-cart-drawer.js:759-819)
  // ============================================================
  function findMatchingVariant(product, modelInfo) {
    if (!modelInfo || !modelInfo.modelName || !product.variants) return null;

    var normalizedModel = modelInfo.modelName.toLowerCase().replace(/\s+/g, ' ').trim();
    var bestMatch = null;
    var acabadoPreference = modelInfo.acabado || null;

    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available === false) continue;

      var vTitle = (v.title || '').toLowerCase().replace(/\s+/g, ' ').trim();
      var vParts = vTitle.split(' / ');
      var vModel = vParts[0].trim();

      if (vModel !== normalizedModel) continue;

      if (!modelInfo.magsafeChoice) {
        if (acabadoPreference && vParts.length >= 2) {
          if (vParts[vParts.length - 1].trim() === acabadoPreference) {
            bestMatch = v;
            break;
          }
          if (!bestMatch) bestMatch = v;
          continue;
        }
        bestMatch = v;
        break;
      }

      var vMagsafe = vParts.length > 1 ? vParts[1].trim() : '';
      var wantsMagsafe = modelInfo.magsafeChoice.toLowerCase();
      var magsafeMatch = false;

      if (wantsMagsafe === 'si' && /^s[ií]$/i.test(vMagsafe)) magsafeMatch = true;
      if (wantsMagsafe === 'no' && /^no$/i.test(vMagsafe)) magsafeMatch = true;

      if (!magsafeMatch) {
        if (!bestMatch) bestMatch = v;
        continue;
      }

      if (acabadoPreference && vParts.length >= 3) {
        var vAcabado = vParts[2].trim();
        if (vAcabado === acabadoPreference) {
          bestMatch = v;
          break;
        }
        if (!bestMatch) bestMatch = v;
        continue;
      }

      bestMatch = v;
      break;
    }

    return bestMatch;
  }

  // ============================================================
  // FETCH RECOMMENDATIONS (covrfly-cart-drawer.js:824-947)
  // ============================================================
  function fetchRecommendations(cart) {
    _currentCart = cart;
    var modelInfo = getCartModelInfo(cart);
    // ── KICKFLIP CARROUSEL FIX CAPA 2 (21-abr-2026) ──
    // Si no se detectó modelo (Kickflip edge case), usar default popular
    // en vez de ocultar. El selector de modelos permite al usuario cambiar.
    if (!modelInfo || !modelInfo.modelName) {
      modelInfo = {
        modelName: 'iPhone 16 Pro Max',
        magsafeChoice: 'Si',
        acabado: null,
        productId: cart.items[0].product_id
      };
    }
    _currentModelInfo = modelInfo;

    _fetchToken++;
    var myToken = _fetchToken;

    // Skeleton loader
    if (!container.querySelector('.cf-upsell')) {
      showSkeleton();
    }

    // IDs de productos ya en el carrito
    _cartProductIds = {};
    cart.items.forEach(function (item) {
      _cartProductIds[item.product_id] = true;
    });

    Promise.all([
      fetch('/recommendations/products.json?product_id=' + modelInfo.productId + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .catch(function () { return { products: [] }; }),
      fetch('/recommendations/products.json?product_id=' + modelInfo.productId + '&limit=10&intent=complementary')
        .then(function (r) { return r.json(); })
        .catch(function () { return { products: [] }; })
    ])
    .then(function (results) {
      if (myToken !== _fetchToken) return;

      var products = (results[0] && results[0].products) ? results[0].products : [];
      var extra = (results[1] && results[1].products) ? results[1].products : [];

      var seenIds = {};
      products.forEach(function (p) { seenIds[p.id] = true; });
      extra.forEach(function (p) {
        if (!seenIds[p.id]) {
          products.push(p);
          seenIds[p.id] = true;
        }
      });

      if (products.length === 0) {
        hideCarousel();
        return;
      }

      var filtered = products.filter(function (p) {
        return !_cartProductIds[p.id];
      });

      _products = filtered;

      var withVariant = [];
      filtered.forEach(function (p) {
        var match = findMatchingVariant(p, modelInfo);
        if (match && match.available !== false) {
          p._matchedVariant = match;
          withVariant.push(p);
        }
      });

      if (withVariant.length < 2) {
        hideCarousel();
        return;
      }

      renderCarousel(withVariant, modelInfo);
    })
    .catch(function () {
      hideCarousel();
    });
  }

  // ============================================================
  // RENDER CAROUSEL (covrfly-cart-drawer.js:952-1199)
  // ============================================================
  function renderCarousel(products, modelInfo) {
    var displayProducts = products.slice(0, 12);

    var html = '<div class="cf-upsell">';

    // Header
    html += '<div class="cf-upsell__header">';
    html += '<p class="cf-upsell__heading">Te puede gustar</p>';
    html += '<p class="cf-upsell__subheading">';
    html += 'Para: <strong>' + escapeHtml(modelInfo.modelName) + '</strong>';
    html += ' <button type="button" class="cf-upsell__change-model">Cambiar modelo \u2192</button>';
    html += '</p>';
    html += '</div>';

    // BUG 2 FIX (19-abr-2026) — Toggle de acabado dinámico por modelo del usuario
    // Espejo del fix en covrfly-cart-drawer.js L1068.
    // Solo mostrar toggle si el MODELO DEL USUARIO realmente tiene 2+ acabados.
    var acabadoOptions = {};
    var userModel = ((modelInfo && modelInfo.modelName) || '').toLowerCase().replace(/\s+/g, ' ').trim();
    displayProducts.forEach(function (p) {
      if (!p.variants || !userModel) return;
      p.variants.forEach(function (v) {
        var vParts = (v.title || '').split(' / ');
        var vModel = (vParts[0] || '').toLowerCase().replace(/\s+/g, ' ').trim();
        if (vModel !== userModel) return;
        var a = getVariantAcabado(v);
        if (a) acabadoOptions[a.toLowerCase()] = a;
      });
    });
    var acabadoCount = Object.keys(acabadoOptions).length;
    var showAcabadoUI = acabadoCount >= 2;

    if (showAcabadoUI) {
      var currentAcabado = (modelInfo.acabado || '').toLowerCase();
      html += '<div class="cf-upsell-acabado-toggle">';
      html += '<span class="cf-upsell-acabado-label">Acabado:</span>';
      var optKeys = Object.keys(acabadoOptions);
      optKeys.sort(function (a, b) { return a === 'glossy' ? -1 : 1; });
      optKeys.forEach(function (key) {
        var isActive = key === currentAcabado ? ' is-active' : '';
        html += '<button type="button" class="cf-acabado-btn' + isActive + '" data-acabado="' + key + '">' + escapeHtml(acabadoOptions[key]) + '</button>';
      });
      html += '</div>';
    }

    // Track
    html += '<div class="cf-upsell__track">';

    var itemCount = 0;
    if (_currentCart && _currentCart.items) {
      _currentCart.items.forEach(function (item) {
        itemCount += item.quantity;
      });
    }
    var nextDiscountPct = 0;
    if (itemCount === 1) nextDiscountPct = 15;
    else if (itemCount === 2) nextDiscountPct = 20;
    else if (itemCount >= 3) nextDiscountPct = 25;

    displayProducts.forEach(function (product) {
      var variant = product._matchedVariant;
      if (!variant) return;

      var img = '';
      if (variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          img = variant.featured_image;
        } else if (variant.featured_image.src) {
          img = variant.featured_image.src;
        }
      }
      if (!img && product.featured_image) {
        img = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || '');
      }
      if (!img && product.images && product.images.length > 0) {
        img = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
      }
      if (img) {
        var imgBase = img.split('?')[0];
        img = imgBase + '?width=200&height=200&crop=center';
      }

      var price = variant.price;
      var priceCents = typeof price === 'string'
        ? Math.round(parseFloat(price) * 100)
        : (price > 10000 ? price : Math.round(price * 100));
      var priceDisplay = formatMoney(priceCents, 'marketing');

      html += '<div class="cf-upsell__card" data-variant-id="' + variant.id + '" role="button" tabindex="0">';
      html += '<div class="cf-upsell__card-inner">';
      html += '<div class="cf-upsell__image-wrap">';
      html += '<img src="' + img + '" alt="' + escapeHtml(product.title) + '" loading="lazy">';
      html += '</div>';
      html += '<div class="cf-upsell__info">';
      html += '<p class="cf-upsell__title">' + escapeHtml(product.title) + '</p>';

      var priceHtml = '';
      if (nextDiscountPct > 0) {
        var discountedCents = Math.round(priceCents * (1 - nextDiscountPct / 100));
        var discountedDisplay = formatMoney(discountedCents, 'marketing');
        priceHtml += '<p class="cf-upsell__price">';
        priceHtml += '<span class="cf-upsell__price-original">' + priceDisplay + '</span>';
        priceHtml += '<span class="cf-upsell__price-final">' + discountedDisplay + '</span>';
        priceHtml += '</p>';
        priceHtml += '<span class="cf-upsell__discount-badge">' + nextDiscountPct + '% OFF</span>';
      } else {
        priceHtml += '<p class="cf-upsell__price">' + priceDisplay + '</p>';
      }
      html += priceHtml;
      html += '</div>';
      html += '</div>';
      html += '</div>';
    });

    // Card "Ver todos"
    html += '<a href="/collections/all-designs" class="cf-upsell__card cf-upsell__card--more">';
    html += '<div class="cf-upsell__card-inner cf-upsell__card-inner--more">';
    html += '<div class="cf-upsell__more-circle">';
    html += '<span class="cf-upsell__more-arrow">\u2192</span>';
    html += '</div>';
    html += '<p class="cf-upsell__title cf-upsell__title--more">Ver todos</p>';
    html += '</div>';
    html += '</a>';

    html += '</div>'; // track

    // Dots
    var totalCards = displayProducts.length + 1;
    if (totalCards > 1) {
      html += '<div class="cf-upsell__dots">';
      for (var d = 0; d < totalCards; d++) {
        var dotActive = d === 0 ? ' is-active' : '';
        html += '<span class="cf-upsell__dot' + dotActive + '"></span>';
      }
      html += '</div>';
    }

    html += '</div>'; // cf-upsell

    container.innerHTML = html;
    container.style.display = 'block';

    // Model sheet singleton (Bomba 14)
    ensureModelSheet(modelInfo);

    // Bind scroll dots
    bindScrollDots();

    setTimeout(function () {
      var el = container.querySelector('.cf-upsell');
      if (el) el.classList.add('has-animated');
    }, 300);
  }

  // ============================================================
  // SKELETON + HIDE
  // ============================================================
  function showSkeleton() {
    container.innerHTML =
      '<div class="cf-upsell cf-upsell--skeleton">' +
        '<div class="cf-upsell__header">' +
          '<div class="cf-skeleton-line" style="width:140px;height:16px;margin-bottom:6px"></div>' +
          '<div class="cf-skeleton-line" style="width:200px;height:13px"></div>' +
        '</div>' +
        '<div class="cf-upsell__track" style="gap:12px">' +
          '<div class="cf-skeleton-card"></div>' +
          '<div class="cf-skeleton-card"></div>' +
          '<div class="cf-skeleton-card"></div>' +
        '</div>' +
      '</div>';
    container.style.display = 'block';
  }

  function hideCarousel() {
    container.innerHTML = '';
    container.style.display = 'none';
  }

  // ============================================================
  // SCROLL DOTS
  // ============================================================
  function bindScrollDots() {
    var track = container.querySelector('.cf-upsell__track');
    var dotsContainer = container.querySelector('.cf-upsell__dots');
    if (!track || !dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('.cf-upsell__dot');
    var cards = track.querySelectorAll('.cf-upsell__card');

    track.addEventListener('scroll', function () {
      if (!cards.length) return;
      var cardWidth = cards[0].offsetWidth;
      var gap = 12;
      var activeIndex = Math.round(track.scrollLeft / (cardWidth + gap));
      if (activeIndex < 0) activeIndex = 0;
      if (activeIndex >= dots.length) activeIndex = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        if (i === activeIndex) dots[i].classList.add('is-active');
        else dots[i].classList.remove('is-active');
      }
    }, { passive: true });
  }

  // ============================================================
  // MODEL SHEET SINGLETON (Bomba 14 + Bomba 7g)
  // ============================================================
  function ensureModelSheet(modelInfo) {
    // FASE 2 (19-abr-2026): remove+create en vez de skip-if-exists.
    // Espejo del patrón drawer L1255-1257. /cart siempre es dueño de SU sheet.
    var existingSheet = document.getElementById('cf-model-sheet');
    if (existingSheet) existingSheet.remove();

    var appleBrand = /Galaxy|Samsung/i.test(modelInfo.modelName) ? '' : ' is-active';
    var samsungBrand = appleBrand ? '' : ' is-active';

    var sheetHtml = '<div class="cf-model-sheet" id="cf-model-sheet">';
    sheetHtml += '<div class="cf-model-sheet__backdrop"></div>';
    sheetHtml += '<div class="cf-model-sheet__panel">';
    sheetHtml += '<div class="cf-handle"><span></span></div>';
    sheetHtml += '<div class="cf-modal-title">Modelo de dispositivo</div>';
    sheetHtml += '<div class="cf-tabs">';
    sheetHtml += '<button type="button" class="cf-tab' + appleBrand + '" data-brand="apple">Apple</button>';
    sheetHtml += '<button type="button" class="cf-tab' + samsungBrand + '" data-brand="samsung">Samsung</button>';
    sheetHtml += '</div>';

    sheetHtml += '<div class="cf-list" data-brand-list="apple"' + (samsungBrand ? ' style="display:none;"' : '') + '>';
    var appleModels = [
      'iPhone 18 Pro Max', 'iPhone 18 Pro',
      'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17 Air', 'iPhone 17',
      'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16',
      'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
      'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
      'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13',
      'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12',
      'iPhone 11 Pro Max', 'iPhone 11 Pro'
    ];
    appleModels.forEach(function (m) {
      var isActive = m === modelInfo.modelName ? ' is-selected' : '';
      sheetHtml += '<button type="button" class="cf-card' + isActive + '" data-model="' + m + '">' + m + '</button>';
    });
    sheetHtml += '</div>';

    sheetHtml += '<div class="cf-list" data-brand-list="samsung"' + (appleBrand ? ' style="display:none;"' : '') + '>';
    var samsungModels = [
      'Galaxy S26 Ultra', 'Galaxy S26+', 'Galaxy S26',
      'Galaxy S25 Ultra', 'Galaxy S25+', 'Galaxy S25',
      'Galaxy S24 Ultra', 'Galaxy S24+', 'Galaxy S24',
      'Galaxy S23 Ultra', 'Galaxy S23+', 'Galaxy S23'
    ];
    samsungModels.forEach(function (m) {
      var isActive = m === modelInfo.modelName ? ' is-selected' : '';
      sheetHtml += '<button type="button" class="cf-card' + isActive + '" data-model="' + m + '">' + m + '</button>';
    });
    sheetHtml += '</div>';
    sheetHtml += '</div></div>';

    document.body.insertAdjacentHTML('beforeend', sheetHtml);
  }

  // ============================================================
  // EVENT DELEGATION (scoped + document level for model sheet)
  // ============================================================

  // Card click — add to cart (Bomba 12)
  container.addEventListener('click', function (e) {
    var card = e.target.closest('.cf-upsell__card[data-variant-id]');
    if (!card) return;
    if (card.classList.contains('cf-upsell__card--more')) return;

    e.preventDefault();
    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) return;

    card.classList.add('is-adding');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Error al agregar');
      return r.json();
    })
    .then(function () {
      // Trigger Section Rendering via PubSub (Bomba 12)
      if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'covrfly-cart-page',
          cartData: null
        });
      } else {
        window.location.reload();
      }
    })
    .catch(function () {
      card.classList.remove('is-adding');
    });
  });

  // Acabado toggle
  container.addEventListener('click', function (e) {
    var btn = e.target.closest('.cf-acabado-btn');
    if (!btn) return;

    var newAcabado = btn.getAttribute('data-acabado');
    if (!newAcabado) return;

    var toggle = btn.closest('.cf-upsell-acabado-toggle');
    if (toggle) {
      toggle.querySelectorAll('.cf-acabado-btn').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
    }

    if (_currentModelInfo) _currentModelInfo.acabado = newAcabado;
    try { sessionStorage.setItem('cf_upsell_acabado', newAcabado); } catch (ex) {}

    if (_products && _products.length > 0 && _currentModelInfo) {
      var withVariant = [];
      _products.forEach(function (p) {
        var match = findMatchingVariant(p, _currentModelInfo);
        if (match && match.available !== false) {
          p._matchedVariant = match;
          withVariant.push(p);
        }
      });
      if (withVariant.length > 0) renderCarousel(withVariant, _currentModelInfo);
    }
  });

  // Change model button
  container.addEventListener('click', function (e) {
    if (e.target.closest('.cf-upsell__change-model')) {
      var sheet = document.getElementById('cf-model-sheet');
      if (sheet) sheet.classList.add('is-open');
    }
  });

  // Model sheet interactions (document level — sheet is in <body>)
  document.addEventListener('click', function (e) {
    var sheet = document.getElementById('cf-model-sheet');
    if (!sheet) return;

    // Backdrop close
    if (e.target.closest('.cf-model-sheet__backdrop')) {
      sheet.classList.remove('is-open');
      return;
    }

    // Brand tabs
    var brandTab = e.target.closest('.cf-tab');
    if (brandTab && sheet.contains(brandTab)) {
      var brand = brandTab.getAttribute('data-brand');
      sheet.querySelectorAll('.cf-tab').forEach(function (t) { t.classList.remove('is-active'); });
      brandTab.classList.add('is-active');
      sheet.querySelectorAll('.cf-list').forEach(function (l) { l.style.display = 'none'; });
      var targetList = sheet.querySelector('[data-brand-list="' + brand + '"]');
      if (targetList) targetList.style.display = 'block';
      return;
    }

    // Model card selection
    var modelCard = e.target.closest('.cf-card');
    if (modelCard && sheet.contains(modelCard)) {
      var newModel = modelCard.getAttribute('data-model');
      if (!newModel) return;

      sheet.classList.remove('is-open');
      try { sessionStorage.setItem('cf_upsell_model', newModel); } catch (ex) {}

      var isSamsung = /Galaxy|Samsung/i.test(newModel);
      var isIphone11 = /iPhone\s*11/i.test(newModel);
      var hasMagsafe = !(isSamsung || isIphone11);

      _currentModelInfo = {
        modelName: newModel,
        magsafeChoice: hasMagsafe
          ? (_currentModelInfo ? _currentModelInfo.magsafeChoice || 'Si' : 'Si')
          : null,
        acabado: _currentModelInfo ? _currentModelInfo.acabado || null : null,
        productId: _currentModelInfo ? _currentModelInfo.productId : 0
      };

      if (_products && _products.length > 0) {
        var withVariant = [];
        _products.forEach(function (p) {
          var match = findMatchingVariant(p, _currentModelInfo);
          if (match && match.available !== false) {
            p._matchedVariant = match;
            withVariant.push(p);
          }
        });

        if (withVariant.length > 0) {
          renderCarousel(withVariant, _currentModelInfo);
        } else {
          container.innerHTML =
            '<div class="cf-upsell">' +
              '<div class="cf-upsell__header">' +
                '<p class="cf-upsell__heading">No hay dise\u00F1os disponibles</p>' +
                '<p class="cf-upsell__subheading">para ' + escapeHtml(newModel) + '. ' +
                '<a href="/collections/all-designs" style="color:#0470E3;text-decoration:none;font-weight:500;">Ver cat\u00E1logo completo \u2192</a></p>' +
              '</div>' +
            '</div>';
        }
      }
    }
  });

  // ============================================================
  // RESIZE OBSERVER BADGE (Bomba A — Commit 10)
  // Clon de covrfly-cart-drawer.js:540-580
  // ============================================================
  (function () {
    var badge = document.getElementById('covrfly-shipping-badge');
    if (!badge) return;

    var _cfBadgeMaxH = 108;

    function measureAndReserveBadge() {
      if (!badge.children.length) return;
      var h = Math.ceil(badge.getBoundingClientRect().height);
      if (h > _cfBadgeMaxH) {
        _cfBadgeMaxH = h;
        badge.style.minHeight = _cfBadgeMaxH + 'px';
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        measureAndReserveBadge();
      });
      ro.observe(badge);
    }

    document.addEventListener('covrfly:cart-updated', measureAndReserveBadge);
    setTimeout(measureAndReserveBadge, 300);
  })();

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          hideCarousel();
          return;
        }
        fetchRecommendations(cart);
      })
      .catch(function () { hideCarousel(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reconnect post Section Rendering
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (evt) {
      // Avoid re-triggering from our own add-to-cart
      if (evt && evt.source === 'covrfly-cart-page') return;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || cart.items.length === 0) {
            hideCarousel();
            return;
          }
          fetchRecommendations(cart);
        });
    });
  }

  // ============================================================
  // FIX 1c (20-abr-2026) — Contador via LECTURA respuestas /cart.js
  // Reemplaza FIX 1b (setTimeout 200ms) que causaba race condition.
  //
  // Diagnostico forense 20-abr-2026 06:58:
  //   Valor inicial 4 → Click + → DOM=4 (STALE)
  //   Click + → DOM=5 (STALE)
  //   Click - → DOM=6 (STALE + INVERTIDO)
  //   Patron: contador SIEMPRE una accion atrasado
  //
  // Causa: mi fetch /cart.js llegaba ANTES de que Shopify terminara
  //        de procesar /cart/change. Recibia cart stale.
  //
  // Solucion nueva: NO hacer fetch propio. En vez de eso, LEER las
  // respuestas de /cart.js que ya pasan por la red (fetch + XHR).
  // Rivon ya hace fetch('/cart.js') y XHR('/cart.js') despues de
  // cada update. Esas respuestas YA tienen item_count correcto.
  //
  // Doble patch:
  //   1. window.fetch → leer respuestas de /cart.js
  //   2. XMLHttpRequest → leer respuestas de /cart.js (Rivon usa esto)
  //
  // Cero fetch propios. Cero race conditions. Siempre sincronizado.
  // ============================================================
  (function () {
    if (!document.querySelector('.cart-page-title__count')) return;

    function updateFromCart(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;
      var ce = document.querySelector('.cart-page-title__count');
      var te = document.querySelector('.cart-page-title');
      if (ce) ce.textContent = cart.item_count;
      if (te) te.style.display = cart.item_count === 0 ? 'none' : '';
    }

    // Patch 1: window.fetch
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        if (input instanceof Request) url = input.url;
        else if (typeof input === 'string') url = input;
        else if (input && typeof input.url === 'string') url = input.url;
      } catch (e) {}

      var result = originalFetch.apply(this, arguments);

      if (url.indexOf('/cart.js') !== -1) {
        result.then(function (r) {
          if (!r || !r.clone) return;
          r.clone().json()
            .then(updateFromCart)
            .catch(function () {});
        }).catch(function () {});
      }

      return result;
    };

    // Patch 2: XMLHttpRequest (Rivon usa esto segun forense)
    var originalXHROpen = XMLHttpRequest.prototype.open;
    var originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._cfUrl = url || '';
      return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr._cfUrl && xhr._cfUrl.indexOf('/cart.js') !== -1) {
        xhr.addEventListener('load', function () {
          if (xhr.status === 200) {
            try {
              var cart = JSON.parse(xhr.responseText);
              updateFromCart(cart);
            } catch (e) {}
          }
        });
      }
      return originalXHRSend.apply(this, arguments);
    };
  })();

  // ============================================================
  // FIX 3b (20-abr-2026) — Agregar .template-cart al body
  // Rivon NO la agrega automaticamente. CSS con :has() es primario,
  // esto es backup para browsers sin soporte :has().
  // ============================================================
  if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0) {
    document.body.classList.add('template-cart');
  }

})();

// ============================================================
// THOUSANDS SEPARATOR FIX (1 mayo 2026)
// /cart no tenia separador de miles (drawer si).
// SOLO inserta comas en numeros >= 1,000. NO modifica nada mas.
// ============================================================
(function () {
  'use strict';

  function addThousandsSeparator(numStr) {
    var parts = numStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function formatPriceText(text) {
    // Solo inserta comas. NO toca el numero, NO toca decimales.
    return text.replace(/(-?\$)(\d+)(\.\d+)?(\s*MXN)?/g, function (match, sign, intPart, decPart, currency) {
      var formatted = addThousandsSeparator(intPart);
      return sign + formatted + (decPart || '') + (currency || '');
    });
  }

  function applyThousandsToCartPage() {
    var selectors = [
      '.totals__subtotal-value',
      '.cart-savings-amount',
      '.cart-shipping-old',
      '.cart-shipping-value.cart-shipping-paid'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        var original = el.textContent;
        var formatted = formatPriceText(original);
        if (formatted !== original) {
          el.textContent = formatted;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyThousandsToCartPage);
  } else {
    applyThousandsToCartPage();
  }

  var cartContainer = document.querySelector('#main-cart-footer')
    || document.querySelector('.cart_subtotal');
  if (cartContainer && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      applyThousandsToCartPage();
    });
    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  console.log('[COVRFLY Cart Page] Thousands separator activo');
})();